<template>
  <el-dialog
    class="add-mat-dialog"
    width="450px"
    append-to-body
    :title="title"
    :visible="visible"
    @update:visible="handleClose"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form';
import { getFcbrMatDetails, saveFcbrMaterial } from '@/api/material';
import { awaitTo } from '@/utils/utils';
import { isEmpty } from '@/utils/is';
import { matUitls } from './utils';

export default {
  components: { HTForm },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isDetails: {
      type: Boolean,
      default: false
    },
    sn: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      i18nPath: '',
      formOptions: {
        inline: true,
        config: {
          labelWidth: 'auto',
          span: 24,
          options: [
            {
              disabled: () => this.isDetails,
              type: 'input',
              prop: 'matName',
              placeholder: '请输入物质名称',
              label: '物质名称'
            },
            {
              disabled: () => this.isDetails,
              type: 'select',
              prop: 'matType',
              placeholder: '请选择物质类型',
              label: '物质类型',
              dataKey: 'matOptions',
              attrs: { type: 'textarea' }
            },
            {
              disabled: () => this.isDetails,
              type: 'input',
              prop: 'remarks',
              placeholder: '请输入备注',
              label: '备注',
              attrs: {
                type: 'textarea',
                autosize: { minRows: 3, maxRows: 6 }
              }
            }
          ],
          operation: {
            span: 24,
            justifyContent: 'flex-end',
            buttons: [
              {
                text: '保存',
                loading: false,
                show: () => {
                  return !this.isDetails;
                },
                type: 'primary',
                handler: async ({ setLoading, getFormRef, data }) => {
                  const formRef = getFormRef();

                  const valid = await formRef.validate();

                  if (!valid) return;

                  setLoading(true);

                  await this.saveMat({
                    matName: data.matName,
                    matType: data.matType,
                    remarks: data.remarks,
                    sn: this.sn,
                    id: this.id
                  });

                  setLoading(false);
                }
              },
              {
                text: '取消',
                loading: false,
                show: () => {
                  return !this.isDetails;
                },
                type: 'primary',
                handler: async () => {
                  this.handleClose();
                }
              }
            ]
          }
        },
        model: {
          matName: '',
          remarks: '',
          matType: ''
        },
        dataSource: {
          matOptions: matUitls.options
        },
        rules: {
          matName: [
            {
              requried: true,
              validator: (_rule, value, callback) => {
                const msg = this.$t('请输入物质名称');

                if (isEmpty(value)) {
                  callback(new Error(msg));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          matType: [
            {
              requried: true,
              validator: (_rule, value, callback) => {
                const msg = this.$t('请选择物质类型');

                if (isEmpty(value)) {
                  callback(new Error(msg));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      }
    };
  },
  computed: {
    title() {
      if (this.id) {
        if (this.isDetails) {
          return this.$t('物质详情');
        } else {
          return this.$t('修改物质');
        }
      } else {
        return this.$t('新增物质');
      }
    }
  },
  methods: {
    handleClose() {
      this.formOptions.model.matName = '';
      this.formOptions.model.remarks = '';

      this.$emit('update:visible', false);
    },
    async saveMat({ matName, remarks, sn, matType, id }) {
      const params = { matName, remarks, sn, matType };

      if (id) params.id = id;

      const [err, res] = await awaitTo(saveFcbrMaterial(params));

      if (err) {
        this.$message.error(err?.message, this.$t('添加失败'));
        return false;
      }

      if (res) {
        this.$message.success(res.message);

        this.$emit('saved', true);

        this.handleClose();
      }

      return true;
    },
    async getMatDetails(id) {
      const [err, res] = await awaitTo(getFcbrMatDetails({ id }));

      if (err) return console.log(err);

      this.formOptions.model.matName = res.data.matName;
      this.formOptions.model.remarks = res.data.remarks;
    }
  },
  watch: {
    visible(n) {
      if (n && this.id) {
        this.getMatDetails(this.id);
      }
    }
  }
};
</script>

<style lang="scss">
.add-mat-dialog {
  .el-row {
    .el-col:last-of-type {
      .el-form-item {
        color: red;
        margin-bottom: 0;
      }
    }
  }
}
</style>
